import { Link } from "react-router-dom";

import { ExternalLinkIcon } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { engagementDetailPath } from "@/lib/paths";
import { PrdDetailView } from "@/screens/Prds/Detail";
import type { Engagement } from "@/types/domain";

// The version list keeps its place while the PRD page (/e/:id) opens in a
// wide sheet — same view, same operations as the standalone page (WED-194).
export const EngagementDetailSheet = ({
  engagement,
  open,
  onOpenChange,
}: {
  engagement: Engagement;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent className="flex w-full flex-col gap-4 overflow-y-auto sm:max-w-6xl">
      <SheetHeader className="flex-row items-center pr-10 text-left">
        <SheetTitle className="sr-only">PRD</SheetTitle>
        <SheetDescription className="sr-only">PRD detail</SheetDescription>
        <Button asChild variant="outline" size="sm" className="ml-auto">
          <Link to={engagementDetailPath(engagement.id)}>
            在新页面打开
            <ExternalLinkIcon />
          </Link>
        </Button>
      </SheetHeader>
      <div className="px-4 pb-6">
        <PrdDetailView engagementId={engagement.id} embedded />
      </div>
    </SheetContent>
  </Sheet>
);

export default EngagementDetailSheet;
